/* angular:styles/component:css;48c1378d4d87163511e1992c9770c559bd7fd7528ee9b424b2ab162abfa5c5f9;C:\Users\medbi\source\repos\MBWeb7\src\app\shared\dd-ngbdropdown.component.ts */
.font90 {
  font-size: 90%;
}
.font75 {
  font-size: 75%;
}
.font50 {
  font-size: 50%;
}
.fontsmall {
  font-size: small;
}
.fontxsmall {
  font-size: x-small;
}
.fontxxsmall {
  font-size: xx-small;
}
.fontsmaller {
  font-size: smaller;
}
.selected-btn {
  background: black;
}
/*# sourceMappingURL=dd-ngbdropdown.component.css.map */
